import { DOCS_URL } from "../../../config/constants.js";
import { EFourColListDesktopLayout, ETitleFontSizes } from "../../../config/enums.js";
import FourColList from "./FourColList.svelte";

export default {
    component: FourColList,
    name: "Four Col List",
    description: "Four-column list layout for structured content",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-fourcollist--docs`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/grid-4x4.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F24f7740123404416ad4e08b3fff803ec",
    inputs: [
        {
            friendlyName: "Header",
            name: "header",
            type: "longText",
        },
        {
            friendlyName: "Heading Level (Semantic)",
            name: "headingLevel",
            type: "text",
            enum: ["h1", "h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h2",
            helperText: "Select the semantic HTML heading level for SEO and accessibility",
            showIf: `options.get('header') !== ''`,
        },
        {
            friendlyName: "Title Font Size",
            name: "titleSize",
            type: "text",
            enum: Object.values(ETitleFontSizes),
            defaultValue: ETitleFontSizes.H2,
            showIf: `options.get('header') !== ''`,
        },
        {
            friendlyName: "CTA To",
            name: "ctaTo",
            type: "text",
        },
        {
            friendlyName: "CTA Text",
            name: "ctaText",
            type: "text",
        },
        {
            friendlyName: "Desktop Layout",
            name: "desktopLayout",
            type: "text",
            enum: Object.values(EFourColListDesktopLayout),
            defaultValue: EFourColListDesktopLayout.FOUR_COLUMNS,
            helperText: "Use Two by Two for list items with longer text.",
        },
        {
            friendlyName: "List Items",
            name: "list",
            type: "list",
            subFields: [
                {
                    friendlyName: "Title",
                    name: "title",
                    type: "text",
                },
                {
                    friendlyName: "List Items (one per line)",
                    name: "listItem",
                    type: "longText",
                },
                {
                    friendlyName: "Link To",
                    name: "linkTo",
                    type: "text",
                },
                {
                    friendlyName: "Link Text",
                    name: "linkText",
                    type: "text",
                },
            ],
        },
    ],
};
